module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-community-322ff83004734702bef7ac596e5d5d80.png";